// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"03ae59a3","976":"b9512d76"}[chunkId] + ".chunk.js";
};